"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const _1 = require(".");
function default_1() {
    const [categoryList, setCategoryList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        (0, api_1.getData)('/api/v1/fond/list')
            .then(res => {
            if (res.status === 200) {
                const categories = res.data.result;
                const transferCategories = categories.filter((item) => (0, _1.getIsTransferCategory)(item.id));
                const salesCategories = categories.filter((item) => !(0, _1.getIsTransferCategory)(item.id) && item.id !== 1014
                // ! 커미션(1014) 노출 안함 (https://fondee.slack.com/archives/CFWEK7CBT/p1691374936246409)
                );
                setCategoryList([...transferCategories, ...salesCategories]);
            }
        })
            .catch(() => alert((0, errors_1.commonErrorMsg)()));
    }, []);
    return categoryList;
}
exports.default = default_1;
